import { createFileRoute } from '@tanstack/react-router';

import { ensureProjectMediaQueryData } from '@/api/media';
import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { requireMediaRead } from '@/features/permissions/route-permissions';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media'
)({
  // beforeLoad runs before any child loader, so child routes never request media without access
  beforeLoad: ({ context: { project }, params }) => {
    requireMediaRead(project.metadata?.permissions, {
      type: 'project',
      projectId: params.projectId,
    });
  },
  loader: ensureProjectMediaQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="media" /> },
});
